export const MB = 1048576;
export const UPLOAD_TOTAL_FILES_COUNT_LIMIT = 10;
export const UPLOAD_ONE_FILE_SIZE_LIMIT: number = 64 * MB;
export const UPLOAD_ALLOWED_EXTENSIONS: string[] = [
  '.png',
  '.bmp',
  '.gif',
  '.jpg',
  '.jpeg',
  '.tif',
  '.tiff',
  '.pdf',
];
